module.exports = "<p>rate-product works!</p>\n"